import { render, staticRenderFns } from "./EstimateChangeDetailModal.vue?vue&type=template&id=2112560a&scoped=true&"
import script from "./EstimateChangeDetailModal.vue?vue&type=script&lang=js&"
export * from "./EstimateChangeDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2112560a",
  null
  
)

export default component.exports